import { render, staticRenderFns } from "./AdminCampaignsTableWrapper.vue?vue&type=template&id=61ae8bd1&scoped=true"
import script from "./AdminCampaignsTableWrapper.vue?vue&type=script&lang=js"
export * from "./AdminCampaignsTableWrapper.vue?vue&type=script&lang=js"
import style0 from "./AdminCampaignsTableWrapper.vue?vue&type=style&index=0&id=61ae8bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ae8bd1",
  null
  
)

export default component.exports